export default __webpack_public_path__ + "static/media/section3-step1.e17bdd4d.png";